import axios from "axios";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { API_URL } from "../const/api";
import { PRIMARY, SECONDARY } from "../const/colors";
import ReactDOMServer from 'react-dom/server';
import CopyIcon from '@mui/icons-material/ContentCopy';
//import { Kushki } from "@kushki/js";
import {
  setShowPagoEfectivo,
  setShowPayRetailer,
  setShowUserDepositModal,
  setUrlPagoEfectivo,
  setUrlPayRetailer,
  setShowPagoFacil,
  setQRPagofacil,
  setShowYape,
  setIdTransYape,
  setmensaje,
  setesperando,
  selectMinimo,
  setShowKushki,
  setUrlKushki,
  setShowAlps,
  setUrlAlps,
} from "../features/modals/modalsSlice";
import {
  selectCurrency,
  selectId,
  selectToken,
  selectUser,
  setNewToken,
  selectPhoneNumber,
  setUserData
} from "../features/user/userSlice";
import {
  errorNotification,
  successNotification,
} from "../utils/toastNotifications";
import { useTranslation } from "react-i18next";
import eth from '../assets/images/ETH-01-01.svg';
import tether from '../assets/images/TETHER-01.svg';
import btc from '../assets/images/BITCOIN-01.svg';
import bnb from '../assets/images/BNB1.svg';
import usdc from '../assets/images/USDC.svg';
import ltc from '../assets/images/LTC-01.svg';
import trx from '../assets/images/TRX-01.svg';
import xrp from '../assets/images/XRP-01.svg';
import doge from '../assets/images/DOGE-01.svg';
import ada from '../assets/images/ADA.svg';
import bch from '../assets/images/BCH-01.svg';
import { formatCurrency } from "../utils/tools";

const initialForm = {
  tipoPago: "",
  nombreBanco: "",
  referencia: "",
  monto1: "",
};

//pay4fun
const initialFormPay4Fun = {
  monto1: "",
  cedula: "",
  nombre: "",
};

const initialFormTotalPago = {
  monto1: "",
  nombre: "",
  idBanco: "",
  referencia: "",
  fecha: moment(new Date()).format("YYYY-MM-DD"),
};
const initialFormTotalPagoBFC = {
  monto1: "",
  nombre: "",
  idBanco: "",
  referencia: "",
  fecha: moment(new Date()).format("YYYY-MM-DD"),
};

const initialFormSafetyPay = {
  monto1: "",
  email: "",
};

const initialFormAstroPay = {
  monto1: "",
};
const initialFormNuvei = {
  monto1: "",
};

const initialFormPayRetailer = {
  idBanco: '',
  monto1: '',
  nombreBanco: '',
  cedula: '',
  email: '',
  direccion: '',
  ciudad: '',
  nombre: '',
  apellido: ''
}

const initialFormTuPay = {
  monto1: ''
}
const initialFormMonnet = {
  monto1: '',
  metodo: ''
}
const initialFormMonnetTarjeta = {
  monto1: '',
  metodo: ''
}
const initialFormMonnetBancos = {
  monto1: '',
  metodo: ''
}
const initialFormMonnetYape = {
  monto1: ''
}
const initialFormPFtigomoney = {
  monto1: '',
  telefono: ''
}
const initialFormPFyape = {
  monto1: '',
  telefono: ''
}
const initialFormPFqr = {
  monto1: ''
}
const initialFormTuPayXAQR = {
  monto1: ''
}
const initialFormTuPayXACC = {
  monto1: ''
}
const initialFormPagoEfectivo = {
  monto1: ''
}
const initialFormCoinspaid = {
  cryptocurrency: '',
  minimo: ''
}
const initialFormSpei = {
  monto1: ''
}
const initialFormBetterArs = {
  monto1: ''
}
const initialFormPix = {
  monto1: '',
  cpf:''
}
const initialFormBoleto= {
  monto1: ''
}
const initialFormBinanceOtro = {
  monto1: ''
}

const initialFormAlps = {
  channel:'',
  document_type:'',
  document:'',
  monto1: ''
}

const initialFormDeuna = {
  channel:'',
  document_type:'',
  document:'',
  monto1: ''
}

const initialFormTotalPagoBNC = {
  monto1: "",
  nombre: "",
  idBanco: "",
  referencia: "",
  fecha: moment(new Date()).format("YYYY-MM-DD"),
};

const initialFormKushkiTransf = {
  monto1: ''
}

const initialFormKushkiEfect = {
  monto1: ''
}

const initialFormKushkiCard = {
  monto1: '',
  card_number:'',
  name: '',
  cvc: '',
  expiryMonth: '',
  expiryYear: '',
}

const initialFormPFqrbisa = {
  monto1: ''
}

const initialFormPFqrMercantil = {
  monto1: ''
}

const initialFormAlpsEfectivoChile = {
  document_type:'',
  document:'',
  monto1: ''
}

const initialFormAlpsTarjetaChile = {
  document_type:'',
  document:'',
  monto1: ''
}

const initialFormAlpsTransfChile = {
  channel:'',
  document_type:'',
  document:'',
  monto1: ''
}

const initialFormOxxo = {
  monto1: '', 
  documento:'',
  tipodocumento:''
}

const initialFormMonnetGTQCASH = {
  monto1: ''
}

const initialFormMonnetGTQTRANSF = {
  monto1: ''
}

const initialFormTransPYG = {
  monto1: ''
}

const initialFormMonnetTarjetaEcu = {
  monto1: '',
  metodo: ''
}

const initialFormMonnetBancosCH = {
  monto1: '',
  metodo: ''
}

export const useDeposit = () => {
  const id_uo = useSelector(selectId);
  const token = useSelector(selectToken);
  const moneda = useSelector(selectCurrency);
  const usuario = useSelector(selectUser);
  const [form, setForm] = useState(initialForm);
  const [formPay4Fun, setFormPay4Fun] = useState(initialFormPay4Fun);
  const [formTotalPago, setFormTotalPago] = useState(initialFormTotalPago);
  const [formTotalPagoBFC, setFormTotalPagoBFC] = useState(initialFormTotalPagoBFC);
  const [formSafetyPay, setFormSafetyPay] = useState(initialFormSafetyPay);
  const [formAstroPay, setFormAstroPay] = useState(initialFormAstroPay);
  const [formNuvei, setFormNuvei] = useState(initialFormNuvei);
  const [formPayRetailer, setFormPayRetailer] = useState(initialFormPayRetailer);
  const [formTuPay, setFormTuPay] = useState(initialFormTuPay);
  const [formTuPayXAQR, setFormTuPayXAQR] = useState(initialFormTuPayXAQR);
  const [formTuPayXACC, setFormTuPayXACC] = useState(initialFormTuPayXACC);
  const [formPagoEfectivo, setFormPagoEfectivo] = useState(initialFormPagoEfectivo);
  const [formMonnet, setFormMonnet] = useState(initialFormMonnet);
  const [formMonnetTarjeta, setFormMonnetTarjeta] = useState(initialFormMonnetTarjeta);
  const [formMonnetBancos, setFormMonnetBancos] = useState(initialFormMonnetBancos);
  const [formMonnetYape, setFormMonnetYape] = useState(initialFormMonnetYape);
  const telefonoInicial = useSelector(selectPhoneNumber);
  const phone = telefonoInicial.startsWith("+591") ? telefonoInicial.replace("+591", "").trim() : telefonoInicial.trim();
  const [formPFtigomoney, setformPFtigomoney] = useState(initialFormPFtigomoney);
  const [formPFyape, setformPFyape] = useState(initialFormPFyape);
  const [formPFqr, setformPFqr] = useState(initialFormPFqr);
  const [formCoinspaid, setformCoinspaid] = useState(initialFormCoinspaid);
  const [auto, setAuto] = useState(false);
  const [formSpei, setformSpei] = useState(initialFormSpei);
  const [formBetterArs, setformBetterArs] = useState(initialFormBetterArs);
  const [formPix, setformPix] = useState(initialFormPix);
  const [formBoleto, setformBoleto] = useState(initialFormBoleto);
  const [formBinanceOtro, setformBinanceOtro] = useState(initialFormBinanceOtro);
  const [formAlps, setformAlps] = useState(initialFormAlps);
  const [formDeuna, setformDeuna] = useState(initialFormDeuna);
  const [formTotalPagoBNC, setFormTotalPagoBNC] = useState(initialFormTotalPagoBNC);
  const [formKuskiTransf, setformKuskiTransf] = useState(initialFormKushkiTransf);
  const [formKushkiEfect, setformKushkiEfect] = useState(initialFormKushkiEfect);
  const [formKushkiCard, setformKushkiCard] = useState(initialFormKushkiCard);
  const [formPFqrbisa, setformPFqrbisa] = useState(initialFormPFqrbisa);
  const [formPFqrMercantil, setformPFqrMercantil] = useState(initialFormPFqrMercantil);
  const [formAlpsEfectivoChile, setformAlpsEfectivoChile] = useState(initialFormAlpsEfectivoChile);
  const [formAlpsTarjetaChile, setformAlpsTarjetaChile] = useState(initialFormAlpsTarjetaChile);
  const [formAlpsTransfChile, setformAlpsTransfChile] = useState(initialFormAlpsTransfChile);
  const [formOxxo, setformOxxo] = useState(initialFormOxxo);
  const [formMonnetGTQCash, setformMonnetGTQCash] = useState(initialFormMonnetGTQCASH);
  const [formMonnetGTQTransf, setformMonnetGTQTransf] = useState(initialFormMonnetGTQTRANSF);
  const [formTransPYG, setformTransPYG] = useState(initialFormTransPYG);
  const [formMonnetTarjetaEcu, setFormMonnetTarjetaEcu] = useState(initialFormMonnetTarjetaEcu);
  const [formMonnetBancosCH, setFormMonnetBancosCH] = useState(initialFormMonnetBancosCH);

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [zelleAct, setZelle] = useState(false);
  const [image, setImage] = useState(null);
  const [bancosRetailer, setBancosRetailer] = useState([]);
  const [loadingBancosRetailer, setLoadingBancosRetailer] = useState(false);
  const [t] = useTranslation('global');
  const minimo = useSelector(selectMinimo);

  const kushki = new window.Kushki({
    merchantId: 'ac738fef1b0045489c1e1e0e0a9aff90',
    inTestEnvironment: false,
  });

  useEffect(() => {
    setformPFtigomoney((prevForm) => ({
      ...prevForm,
      telefono: phone // Inicializa el estado con el número de teléfono cuando el componente se monta o el número de teléfono cambia
    }));
  }, [phone]);

  useEffect(() => {
    setformPFyape((prevForm) => ({
      ...prevForm,
      telefono: phone // Inicializa el estado con el número de teléfono cuando el componente se monta o el número de teléfono cambia
    }));
  }, [phone]);

   // Nuevo useEffect para cargar datos
  useEffect(() => {
    const loadData = async () => {
      let body = { id: id_uo, token: token };
      try {
        const res = await axios.post(API_URL + "user", body);
        dispatch(setNewToken(res.data.token));
        if (res.data.status === 1) {
          dispatch(setUserData(res.data.response));
        }
      } catch (error) {
        //console.log(error);
      }
    };
    loadData();
  }, []); 

  useEffect(()=>{
    const loadBancosRetailer = async () => {
      const body = {id_uo, token, moneda}
      setLoadingBancosRetailer(true);
      const resRetailer = await axios.post(API_URL+'getPaymentMethods', body);
      if(resRetailer.data.status===1) {
        let orden = {'ONLINE': 1, 'CASH': 2};
        let bancos = resRetailer.data.response;
        bancos = bancos.sort(((a, b) => orden[a.channel] - orden[b.channel]))
        if(moneda==='BRL') {
          let aux = ['PIX', 'Boleto', 'Boleto Rápido'];
          bancos = [...bancos.map(item => aux.includes(item.name) ? item : false).filter(fil=>fil), ...bancos.map(item => aux.includes(item.name) ? false : item).filter(fil=>fil)];
        } else {
          if(moneda==='Sol') {
            let aux = ['Banco de Crédito'];
            bancos = [...bancos.map(item => aux.includes(item.name) ? item : false).filter(fil=>fil), ...bancos.map(item => aux.includes(item.name) ? false : item).filter(fil=>fil)];
          } else {
            if(moneda.toUpperCase()==='MXN') {
              let orden2 = {'OXXO': 1, 'BBVA Bancomer': 2, 'Santander': 3, 'Scotiabank':4, 'Banco Azteca':5,'Banorte':6, 'SPEI':7, 'Soriana':8, 'OpenPay':9, 'Calimax':10,'Farmacias Santa Maria':11};
              bancos = bancos.sort(((a, b) => orden2[a.name] - orden2[b.name]));
            }
          }
        }
        setBancosRetailer(bancos);
        setLoadingBancosRetailer(false)
      }
    }
    if((usuario==='test'||usuario==='test2'||usuario==='test3'||usuario.toLowerCase()==='test4'||usuario.toLowerCase()==='test5'||usuario.toLowerCase()==='test6'||usuario==='testcrc'||usuario==='testbrasil')&&(moneda==='$'||moneda==='BRL'||moneda==='CLP'||moneda==='MXN'||moneda==='COP'||moneda==='CRC'||moneda==='Sol'||moneda==='ARS')) {
      loadBancosRetailer()
    }
  },[])


  const handleClose = () => {
    dispatch(setShowUserDepositModal({open: false, type: false}));
    setImage(null);
  };

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });

    if (e.target.name === "nombreBanco") {
      if (
        e.target.value.toUpperCase() === "YAPE(YAPE)" ||
        e.target.value.toUpperCase() === "MERCADO PAGO(MERCADO PAGO)" ||
        e.target.value.toUpperCase() === "UALA(UALA)" ||
        e.target.value.toUpperCase() === "PAYPAL(PAYPAL)" ||
        e.target.value.toUpperCase() === "PLIN(PLIN)"
      ) {
        setForm({
          ...form,
          nombreBanco: e.target.value,
          referencia: "NO APLICA",
        });
        setZelle(false);
      } else {
        if (e.target.value.toUpperCase() === "ZELLE(ZELLE)") setZelle(true);
        else setZelle(false);
        setForm({ ...form, nombreBanco: e.target.value, referencia: "" });
      }
    }
  };

  const handleChangeRetailer = (e) => {
    setFormPay4Fun({
      ...formPay4Fun,
      [e.target.name]: e.target.value,
    });

  };
  const handleChangePayRetailer = (e) => {
    setFormPayRetailer({
      ...formPayRetailer, 
      [e.target.name]: e.target.value
    });
  }

  const handleChangeTotalPago = (e) => {
    setFormTotalPago({
      ...formTotalPago,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeTotalPagoBFC = (e) => {
    setFormTotalPagoBFC({
      ...formTotalPagoBFC,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeSafetyPay = (e) => {
    setFormSafetyPay({
      ...formSafetyPay,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeAstroPay = (e) => {
    setFormAstroPay({
      ...formAstroPay,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeNuvei = (e) => {
    setFormNuvei({
      ...formNuvei,
      [e.target.name]: e.target.value,
    });
  };
  const handleChangeTuPay = (e) => {
    setFormTuPay({
      ...formTuPay,
      [e.target.name]: e.target.value,
    });
  };
  const handleChangeTuPayXAQR = (e) => {
    setFormTuPayXAQR({
      ...formTuPayXAQR,
      [e.target.name]: e.target.value,
    });
  };
  const handleChangeTuPayXACC = (e) => {
    setFormTuPayXACC({
      ...formTuPayXACC,
      [e.target.name]: e.target.value,
    });
  };
  const handleChangePagoEfectivo = (e) => {
    setFormPagoEfectivo({
      ...formTuPay,
      [e.target.name]: e.target.value,
    });
  };
  const handleChangeMonnet = (e) => {
    setFormMonnet({
      ...formMonnet,
      [e.target.name]: e.target.value,
    });
  };
  const handleChangeMonnetTarjeta = (e) => {
    setFormMonnetTarjeta({
      ...formMonnetTarjeta,
      [e.target.name]: e.target.value,
    });
  };
  const handleChangeMonnetBancos = (e) => {
    setFormMonnetBancos({
      ...formMonnetBancos,
      [e.target.name]: e.target.value,
    });
  };
  const handleChangeMonnetYape = (e) => {
    setFormMonnetYape({
      ...formMonnetYape,
      [e.target.name]: e.target.value,
    });
  };
  const handleChangePFtigomoney = (e) => {
    setformPFtigomoney({
      ...formPFtigomoney,
      [e.target.name]: e.target.value,
    });
  };
  const handleChangePFyape = (e) => {
    setformPFyape({
      ...formPFyape,
      [e.target.name]: e.target.value,
    });
  };
  const handleChangePFqr = (e) => {
    setformPFqr({
      ...formPFqr,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeCoinspaid = (e) => {
    setformCoinspaid({
      ...formCoinspaid,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeSpei = (e) => {
    setformSpei({
      ...formSpei,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeBetterArs = (e) => {
    setformBetterArs({
      ...formBetterArs,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangePix = (e) => {
    setformPix({
      ...formPix,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeBoleto = (e) => {
    setformBoleto({
      ...formBoleto,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeBinanceOtro = (e) => {
    setformBinanceOtro({
      ...formBinanceOtro,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeAlps = (e) => {
    setformAlps({
      ...formAlps,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeDeuna = (e) => {
    setformDeuna({
      ...formDeuna,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeKuskiTransf = (e) => {
    setformKuskiTransf({
      ...formKuskiTransf,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeTotalPagoBNC = (e) => {
    setFormTotalPagoBNC({
      ...formTotalPagoBNC,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeKushkiEfect = (e) => {
    setformKushkiEfect({
      ...formKushkiEfect,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeKushkiCard = (e) => {
    setformKushkiCard({
      ...formKushkiCard,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangePFqrbisa = (e) => {
    setformPFqrbisa({
      ...formPFqrbisa,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangePFqrMercantil = (e) => {
    setformPFqrMercantil({
      ...formPFqrMercantil,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeAlpsEfectivoChile = (e) => {
    setformAlpsEfectivoChile({
      ...formAlpsEfectivoChile,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeAlpsTarjetaChile = (e) => {
    setformAlpsTarjetaChile({
      ...formAlpsTarjetaChile,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeAlpsTransfChile = (e) => {
    setformAlpsTransfChile({
      ...formAlpsTransfChile,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeOxxo = (e) => {
    setformOxxo({
      ...formOxxo,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeMonnetGTQCash = (e) => {
    setformMonnetGTQCash({
      ...formMonnetGTQCash,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeMonnetGTQTransf = (e) => {
    setformMonnetGTQTransf({
      ...formMonnetGTQTransf,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeTransPYG = (e) => {
    setformTransPYG({
      ...formTransPYG,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeMonnetTarjetaEcu = (e) => {
    setFormMonnetTarjetaEcu({
      ...formMonnetTarjetaEcu,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeMonnetBancosCH = (e) => {
    setFormMonnetBancosCH({
      ...formMonnetBancosCH,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.tipoPago)
      return errorNotification(
        "Por favor seleccione el tipo de pago",
        "top-center"
      );
    if (!form.nombreBanco)
      return errorNotification(
        "Por favor seleccione el nombre del banco",
        "top-center"
      );
    if (!form.referencia || !form.referencia.trim())
      return errorNotification(
        "Por favor ingrese el número de comprobante",
        "top-center"
      );
    if (!form.monto1 || !form.monto1.trim())
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );
    //if((zelleAct||moneda==='ARS') && (!form.nombreTitular || !form.nombreTitular.trim())) return errorNotification('Por favor ingrese el nombre del titular');
    let monto = parseFloat(form.monto1.replaceAll(".", "").replace(",", "."));
    if (monto <= 0)
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );

    setLoading(true);
    const body = {
      ...form,
      id_uo,
      token,
      moneda,
      usuario,
      monto1: monto,
    };
    const res = await axios.post(API_URL + "notificarDeposito", body);
    dispatch(setNewToken(res.data.token));
    if (res.data.status === 1) {
      if (typeof res.data.response === "number") {
        if (image) {
          let f = new FormData();
          f.append("images", image);
          f.append("tok", res.data.response);
          try {
            const uploadImg = await axios.post(
              "https://notificaciones.betsfactory.co/upload.php",
              f
            );
          } catch (error) {
            //console.log(error);
          }
        }
        let verificando = {
          title: `Enviada satisfactoriamente.`,
          text: `Su solicitud de depósito ha sido enviada satisfactoriamente.`,
          allowOutsideClick: true,
          icon: "success",
          background: SECONDARY,
          color: "#fff",
          showConfirmButton: true,
          confirmButtonColor: PRIMARY,
          confirmButtonText: "Aceptar",
        };
        Swal.fire(verificando);
        handleClose();
        setLoading(false);
      } else {
        if(res.data.response.includes("en espera")) {
          let verificando = {
            title: `En espera.`,
            text: `${res.data.response}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificando);
          handleClose();
        }else{
          errorNotification(res.data.response, "top-center");
        }
        setLoading(false);
      }
    }
  };

  const submitPagoEfectivo = async (e) => {
    e.preventDefault();
    let monto = parseFloat(
      formPagoEfectivo.monto1.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    setLoading(true);
    let body = {
      ...formPay4Fun,
      tipoPago: "PagoEfectivo",
      nombreBanco: "PagoEfectivo",
      referencia: "PagoEfectivo",
      monto1: monto,
      id_uo,
      token,
      moneda,
      usuario,
    };
    const res = await axios.post(API_URL + "notificarDeposito", body);
    if (res.data.status === 1) {
      dispatch(setNewToken(res.data.token));
      dispatch(setUrlPagoEfectivo(res.data.response));
      dispatch(setShowPagoEfectivo(true));
      handleClose();
      setLoading(false);
    } else {
      if(res.data.response.includes("en espera")) {
        let verificando = {
          title: `En espera.`,
          text: `${res.data.response}`,
          allowOutsideClick: true,
          icon: "info",
          background: SECONDARY,
          color: "#fff",
          showConfirmButton: true,
          confirmButtonColor: PRIMARY,
          confirmButtonText: "Aceptar",
        };
        Swal.fire(verificando);
        handleClose();
      }else{
        dispatch(setNewToken(res.data.token));
      }
      
    }
  };

  const submitPay4Fun = async (e) => {
    e.preventDefault();

    if (!formPay4Fun.monto1 || !formPay4Fun.monto1.trim())
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );
    let monto = parseFloat(
      formPay4Fun.monto1.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    if (monto <= 0)
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );

    setLoading(true);
    let body = {
      ...formPay4Fun,
      monto1: monto,
      id_uo,
      token,
      usuario,
    };
    const res = await axios.post(API_URL + "generarSolicitudDepositoP4F", body);
    if (res.data.error === 0) {
      if (res.data.url) {
        let url = res.data.url;
        window.open(url);
        handleClose();
      }
      setLoading(false);
    } else {
      if (res.data.error) {
        if(res.data.error.includes("en espera")) {
          let verificando = {
            title: `En espera.`,
            text: `${res.data.error}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificando);
          handleClose();
        }else{
          errorNotification(res.data.error, "top-center");
        }
        setLoading(false);
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
        setLoading(false);
      }
    }
  };

  const submitTotalPago = async (e) => {
    e.preventDefault();
    for (let x in formTotalPago) {
      if (formTotalPago[x] === "")
        return errorNotification(
          "Por favor rellene todos los campos",
          "top-center"
        );
    }
    let monto = parseFloat(
      formTotalPago.monto1.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    setLoading(true);
    const body = {
      ...formTotalPago,
      fecha: moment(formTotalPago.fecha).format("DD/MM/YYYY"),
      monto1: monto,
      id_uo,
      usuario,
    };
    let verificando = {
      title: `PAGO EN VERIFICACIÓN.`,
      text: "Estamos verificando su pago, este proceso puede tardar hasta 5 minutos.",
      allowOutsideClick: true,
      icon: "info",
      background: SECONDARY,
      color: "#fff",
      showConfirmButton: true,
      confirmButtonColor: PRIMARY,
      confirmButtonText: "Aceptar",
    };
    Swal.fire(verificando);
    handleClose();
    setLoading(false);

    const res = await axios.post(API_URL + "createTransactionVe", body);
    if (res.data.error === 0) {
      Swal.close();
      let verificado = {
        title: `PAGO VERIFICADO.`,
        text: `Su depósito ha sido procesado satisfactoriamente.`,
        allowOutsideClick: true,
        icon: "success",
        background: SECONDARY,
        color: "#fff",
        showConfirmButton: true,
        confirmButtonColor: PRIMARY,
        confirmButtonText: "Aceptar",
      };
      Swal.fire(verificado);
    } else {
      Swal.close();
      if (res.data.error) {
        if(res.data.error.includes("activa")) {
          let verificado = {
            title: `En espera.`,
            text: `${res.data.error}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificado);
          handleClose();
        }else{
          if(res.data.error.includes("IDPAGO")) {
            let verificado = {
              title: `Ha ocurrido un error.`,
              text: `${res.data.error}`,
              allowOutsideClick: true,
              icon: "info",
              background: SECONDARY,
              color: "#fff",
              showConfirmButton: true,
              confirmButtonColor: PRIMARY,
              confirmButtonText: "Aceptar",
            };
            Swal.fire(verificado);
            handleClose();
          }else{
            errorNotification(res.data.error, "top-center");
          }
        }
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
      }
    }
  };

  const submitTotalPagoBFC = async (e) => {
    e.preventDefault();
    for (let x in formTotalPagoBFC) {
      if (formTotalPagoBFC[x] === "")
        return errorNotification(
          "Por favor rellene todos los campos",
          "top-center"
        );
    }
    let monto = parseFloat(
      formTotalPagoBFC.monto1.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    setLoading(true);
    const body = {
      ...formTotalPagoBFC,
      fecha: moment(formTotalPagoBFC.fecha).format("DD/MM/YYYY"),
      monto1: monto,
      id_uo,
      usuario,
    };
    let verificando = {
      title: `PAGO EN VERIFICACIÓN.`,
      text: "Estamos verificando su pago, este proceso puede tardar hasta 5 minutos.",
      allowOutsideClick: true,
      icon: "info",
      background: SECONDARY,
      color: "#fff",
      showConfirmButton: true,
      confirmButtonColor: PRIMARY,
      confirmButtonText: "Aceptar",
    };
    Swal.fire(verificando);
    handleClose();
    setLoading(false);

    const res = await axios.post(API_URL + "createTransactionVe", body);
    if (res.data.error === 0) {
      Swal.close();
      let verificado = {
        title: `PAGO VERIFICADO.`,
        text: `Su depósito ha sido procesado satisfactoriamente.`,
        allowOutsideClick: true,
        icon: "success",
        background: SECONDARY,
        color: "#fff",
        showConfirmButton: true,
        confirmButtonColor: PRIMARY,
        confirmButtonText: "Aceptar",
      };
      Swal.fire(verificado);
    } else {
      Swal.close();
      if (res.data.error) {
        if(res.data.error.includes("activa")) {
          let verificado = {
            title: `En espera.`,
            text: `${res.data.error}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificado);
          handleClose();
        }else{
          if(res.data.error.includes("IDPAGO")) {
            let verificado = {
              title: `Ha ocurrido un error.`,
              text: `${res.data.error}`,
              allowOutsideClick: true,
              icon: "info",
              background: SECONDARY,
              color: "#fff",
              showConfirmButton: true,
              confirmButtonColor: PRIMARY,
              confirmButtonText: "Aceptar",
            };
            Swal.fire(verificado);
            handleClose();
          }else{
            errorNotification(res.data.error, "top-center");
          }
        }
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
      }
    }
  };

  const submitSafetypay = async (e) => {
    e.preventDefault();

    if (!formSafetyPay.monto1 || !formSafetyPay.monto1.trim())
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );
    if (!formSafetyPay.email)
      return errorNotification("Por favor ingrese su email", "top-center");

    let monto = parseFloat(
      formSafetyPay.monto1.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);

    if (monto <= 0)
      return errorNotification(
        "El monto a depositar debe ser mayor a 0",
        "top-center"
      );

    setLoading(true);
    let body = {
      ...formSafetyPay,
      monto1: monto,
      id_uo,
      usuario,
      moneda,
    };

    const res = await axios.post(
      API_URL + "generarSolicitudDepositoSafetyPay",
      body
    );
    if (res.data.error === 0) {
      if (res.data.url) {
        let url = res.data.url;
        window.open(url);
        handleClose();
      }
      setLoading(false);
    } else {
      if (res.data.error) {
        if(res.data.error.includes("en espera")) {
          let verificado = {
            title: `En espera.`,
            text: `${res.data.error}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificado);
          handleClose();
        }else{
          errorNotification(res.data.error, "top-center");
        }
        setLoading(false);
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
        setLoading(false);
      }
    }
  };

  const submitAstroPay = async (e) => {
    e.preventDefault();
    if (!formAstroPay.monto1 || !formAstroPay.monto1.trim())
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );
    let monto = parseFloat(
      formAstroPay.monto1.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    if (monto <= 0)
      return errorNotification(
        "El monto a depositar debe ser mayor a 0",
        "top-center"
      );
    setLoading(true);
    let body = {
      monto1: monto,
      id_uo,
      usuario,
      moneda,
    };

    const res = await axios.post(
      API_URL + "generarSolicitudDepositoAstroPay",
      body
    );
    if (res.data.error === 0) {
      if (res.data.response) {
        let url = res.data.response.url;
        handleClose();
        window.location.href = url; // Redirige en la misma pestaña
      }
      setLoading(false);
    } else {
      if (res.data.error) {
        if(res.data.error.includes("depósito activa")) {
          let verificado = {
            title: `En espera.`,
            text: `${res.data.error}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificado);
          handleClose();
        }else{
          if(res.data.error.includes("procesar su solicitud")) {
            let verificado = {
              title: `Error.`,
              text: `${res.data.error}`,
              allowOutsideClick: true,
              icon: "info",
              background: SECONDARY,
              color: "#fff",
              showConfirmButton: true,
              confirmButtonColor: PRIMARY,
              confirmButtonText: "Aceptar",
            };
            Swal.fire(verificado);
            handleClose();
          }else{
            errorNotification(res.data.error, "top-center");
          }
          
        }
        setLoading(false);
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
        setLoading(false);
      }
    }
  };

  const submitNuvei = async (e) => {
    e.preventDefault();
    if (!formNuvei.monto1 || !formNuvei.monto1.trim())
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );
    let monto = parseFloat(
      formNuvei.monto1.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    if (monto <= 0)
      return errorNotification(
        "El monto a depositar debe ser mayor a 0",
        "top-center"
      );
    setLoading(true);
    let body = {
      monto1: monto,
      id_uo,
      token,
      usuario,
      moneda,
    };

    const res = await axios.post(
      API_URL + "generarSolicitudDepositoNuvei",
      body
    );
    if (res.data.error === 0) {
      console.log(res.data);
      if (res.data.url) {
        let url = res.data.url;
        window.open(url);
        handleClose();
      }
      setLoading(false);
    } else {
      if (res.data.error) {
        if(res.data.error.includes("en espera")) {
          let verificado = {
            title: `En espera.`,
            text: `${res.data.error}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificado);
          handleClose();
        }else{
          errorNotification(res.data.error, "top-center");
        }
        setLoading(false);
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
        setLoading(false);
      }
    }
  };

  const submitPayRetailer = async(e) => {
    e.preventDefault();
    
    if(!formPayRetailer.nombreBanco) return errorNotification('Por favor seleccione el nombre del banco');
    if(!formPayRetailer.nombre) return errorNotification('Por favor ingrese el nombre del titular');
    if(!formPayRetailer.apellido || !formPayRetailer.apellido.trim()) return errorNotification('Por favor ingrese el apellido del titular');
    if(!formPayRetailer.cedula || !formPayRetailer.cedula.trim()) return errorNotification('Por favor ingrese el documento de identidad del titular');
    if(!formPayRetailer.email || !formPayRetailer.email.trim()) return errorNotification('Por favor ingrese el email del titular');
    if(!formPayRetailer.monto1 || !formPayRetailer.monto1.trim()) return errorNotification('Por favor ingrese el monto a depositar');
    let monto = parseFloat(formPayRetailer.monto1.replaceAll('.', '').replace(',', '.')).toFixed(2);
    if(monto<=0) return errorNotification('Por favor ingrese el monto a depositar');
  
    if((moneda==='COP'||moneda==='BRL')&&(!formPayRetailer.ciudad||!formPayRetailer.ciudad.trim())) return errorNotification('Por favor ingrese la ciudad');
    if((moneda==='COP'||moneda==='BRL')&&(!formPayRetailer.direccion||!formPayRetailer.direccion.trim())) return errorNotification('Por favor ingrese la dirección');
  
    setLoading(true);
    let [nombreB, idB] = formPayRetailer.nombreBanco.split('_');
    let body = {
      ...formPayRetailer,
      nombreBanco: nombreB,
      idBanco: idB,
      monto1:monto,
      id_uo, token, moneda, usuario
    }
    const res = await axios.post(API_URL+'generarSolicitudDepositoRetail', body);
  
    console.log(res.data);
  
    if(res.data.status) {
      if(res.data.url) {
        dispatch(setUrlPayRetailer(res.data.url));
        dispatch(setShowPayRetailer(true));
        handleClose();
      }
      setLoading(false);
    } else {
      if(res.data.error) {
        if(res.data.error.includes("en espera")) {
          let verificado = {
            title: `En espera.`,
            text: `${res.data.error}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificado);
          handleClose();
        }else{
          errorNotification(res.data.error, "top-center");
        }
        setLoading(false);
      } else {
        errorNotification("Ha ocurrido un error, por favor intente de nuevo");
        setLoading(false);
      }
    }
  }

  const submitTuPay = async(e) => {
    e.preventDefault();

    if (!formTuPay.monto1 || !formTuPay.monto1.trim())
    return errorNotification(
      "Por favor ingrese el monto a depositar",
      "top-center"
    );
    let monto = parseFloat(
      formTuPay.monto1.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    if (monto <= 0)
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );

    setLoading(true);
    let body = {
      ...formTuPay,
      monto1: monto,
      id_uo,
      token,
      usuario,
      moneda
    };
    const res = await axios.post(API_URL + "generarSolicitudDepositoTuPay", body);
    console.log(res.data);
    if (res.data.error === 0) {
      if (res.data.url) {
        let url = res.data.url;
        window.open(url);
        handleClose();
      }
      setLoading(false);
    } else {
      if (res.data.error) {
        if(res.data.error.includes("en espera")) {
          let verificado = {
            title: `En espera.`,
            text: `${res.data.error}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificado);
          handleClose();
        }else{
          errorNotification(res.data.error, "top-center");
        }
        setLoading(false);
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
        setLoading(false);
      }
    }
  }

  const submitTuPayXAQR = async(e) => {
    e.preventDefault();

    if (!formTuPayXAQR.monto1 || !formTuPayXAQR.monto1.trim())
    return errorNotification(
      "Por favor ingrese el monto a depositar",
      "top-center"
    );
    let monto = parseFloat(
      formTuPayXAQR.monto1.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    if (monto <= 0)
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );

    setLoading(true);
    let body = {
      ...formTuPayXAQR,
      monto1: monto,
      tipo: "XAQR",
      id_uo,
      token,
      usuario,
      moneda
    };
    const res = await axios.post(API_URL + "generarSolicitudDepositoTuPay", body);
    console.log(res.data);
    if (res.data.error === 0) {
      if (res.data.url) {
        let url = res.data.url;
        window.open(url);
        handleClose();
      }
      setLoading(false);
    } else {
      if (res.data.error) {
        if(res.data.error.includes("en espera")) {
          let verificado = {
            title: `En espera.`,
            text: `${res.data.error}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificado);
          handleClose();
        }else{
          errorNotification(res.data.error, "top-center");
        }
        setLoading(false);
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
        setLoading(false);
      }
    }
  }

  const submitTuPayXACC = async(e) => {
    e.preventDefault();

    if (!formTuPayXACC.monto1 || !formTuPayXACC.monto1.trim())
    return errorNotification(
      "Por favor ingrese el monto a depositar",
      "top-center"
    );
    let monto = parseFloat(
      formTuPayXACC.monto1.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    if (monto <= 0)
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );

    setLoading(true);
    let body = {
      ...formTuPayXACC,
      monto1: monto,
      tipo: "XACC",
      id_uo,
      token,
      usuario,
      moneda
    };
    const res = await axios.post(API_URL + "generarSolicitudDepositoTuPay", body);
    console.log(res.data);
    if (res.data.error === 0) {
      if (res.data.url) {
        let url = res.data.url;
        window.open(url);
        handleClose();
      }
      setLoading(false);
    } else {
      if (res.data.error) {
        if(res.data.error.includes("en espera")) {
          let verificado = {
            title: `En espera.`,
            text: `${res.data.error}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificado);
          handleClose();
        }else{
          errorNotification(res.data.error, "top-center");
        }
        setLoading(false);
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
        setLoading(false);
      }
    }
  }

  const submitMonnet = async(e) => {
    e.preventDefault();

    if (!formMonnet.monto1 || !formMonnet.monto1.trim())
    return errorNotification(
      "Por favor ingrese el monto a depositar",
      "top-center"
    );

    if (!formMonnet.metodo || !formMonnet.metodo.trim())
    return errorNotification(
      "Por favor seleccione el metodo de pago",
      "top-center"
    );
    let monto = parseFloat(
      formMonnet.monto1.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    if (monto <= 0)
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );

    setLoading(true);
    let body = {
      ...formMonnet,
      amount: monto,
      id_uo,
      token,
      payment_method: formMonnet.metodo,

    };
    const res = await axios.post(API_URL + "createDepositTransaction", body);
    if (res.data.code === 200) {
      if (res.data.response_data.url) {
        let url = res.data.response_data.url;
        window.open(url);
        handleClose();
      }
      setLoading(false);
    } else {
      if (res.data.message) {
        if(res.data.message.includes("en espera")) {
          let verificado = {
            title: `En espera.`,
            text: `${res.data.message}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificado);
          handleClose();
        }else{
          errorNotification(res.data.message, "top-center");
        }
        setLoading(false);
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
        setLoading(false);
      }
    }
  }

  const submitMonnetTarjeta = async(e) => {
    e.preventDefault();

    if (!formMonnetTarjeta.monto1 || !formMonnetTarjeta.monto1.trim())
    return errorNotification(
      "Por favor ingrese el monto a depositar",
      "top-center"
    );
   if (!formMonnetTarjeta.metodo || !formMonnetTarjeta.metodo.trim())
    return errorNotification(
      "Por favor seleccione el metodo de pago",
      "top-center"
    );
    let monto = parseFloat(
      formMonnetTarjeta.monto1.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    if (monto <= 0)
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );

    setLoading(true);
    let body = {
      ...formMonnetTarjeta,
      amount: monto,
      id_uo,
      token,
      payment_method: formMonnetTarjeta.metodo,

    };
    const res = await axios.post(API_URL + "createDepositTransaction", body);
    if (res.data.code === 200) {
      if (res.data.response_data.url) {
        let url = res.data.response_data.url;
        handleClose();
        window.location.href = url; // Redirige en la misma pestaña
      }
      setLoading(false);
    } else {
      if (res.data.message) {
        if(res.data.message.includes("en espera")) {
          let verificado = {
            title: `En espera.`,
            text: `${res.data.message}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificado);
          handleClose();
        }else{
          errorNotification(res.data.message, "top-center");
        }
        setLoading(false);
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
        setLoading(false);
      }
    }
  }

  const submitMonnetBancos = async(e) => {
    e.preventDefault();

    if (!formMonnetBancos.monto1 || !formMonnetBancos.monto1.trim())
    return errorNotification(
      "Por favor ingrese el monto a depositar",
      "top-center"
    );
   if (!formMonnetBancos.metodo || !formMonnetBancos.metodo.trim())
    return errorNotification(
      "Por favor seleccione el metodo de pago",
      "top-center"
    );
    let monto = parseFloat(
      formMonnetBancos.monto1.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    if (monto <= 0)
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );

    setLoading(true);
    let body = {
      ...formMonnetBancos,
      amount: monto,
      id_uo,
      token,
      payment_method: formMonnetBancos.metodo,

    };
    const res = await axios.post(API_URL + "createDepositTransaction", body);
    if (res.data.code === 200) {
      if (res.data.response_data.url) {
        let url = res.data.response_data.url;
        window.open(url);
        handleClose();
      }
      setLoading(false);
    } else {
      if (res.data.message) {
        if(res.data.message.includes("en espera")) {
          let verificado = {
            title: `En espera.`,
            text: `${res.data.message}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificado);
          handleClose();
        }else{
          errorNotification(res.data.message, "top-center");
        }
        setLoading(false);
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
        setLoading(false);
      }
    }
  }

  const submitMonnetYape = async(e) => {
    e.preventDefault();

    if (!formMonnetYape.monto1 || !formMonnetYape.monto1.trim())
    return errorNotification(
      "Por favor ingrese el monto a depositar",
      "top-center"
    );

    let monto = parseFloat(
      formMonnetYape.monto1.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    if (monto <= 0)
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );

    setLoading(true);
    let body = {
      ...formMonnetYape,
      amount: monto,
      id_uo,
      token,
      payment_method: 'Wallet',

    };
    const res = await axios.post(API_URL + "createDepositTransaction", body);
    if (res.data.code === 200) {
      if (res.data.response_data.url) {
        let url = res.data.response_data.url;
        window.open(url);
        handleClose();
      }
      setLoading(false);
    } else {
      if (res.data.message) {
        if(res.data.message.includes("en espera")) {
          let verificado = {
            title: `En espera.`,
            text: `${res.data.message}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificado);
          handleClose();
        }else{
          errorNotification(res.data.message, "top-center");
        }
        setLoading(false);
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
        setLoading(false);
      }
    }
  }
  const submitPFtigomoney = async(e) => {
    e.preventDefault();

    if (!formPFtigomoney.monto1 || !formPFtigomoney.monto1.trim())
    return errorNotification(
      "Por favor ingrese el monto a depositar",
      "top-center"
    );
  if (!formPFtigomoney.telefono || !formPFtigomoney.telefono.trim())
    return errorNotification(
      "Por favor ingrese el numero de billetera Tigomoney",
      "top-center"
    );
    let monto = parseFloat(
      formPFtigomoney.monto1.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    if (monto <= 0)
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );

    setLoading(true);
    let body = {
      ...formPFtigomoney,
      amount: monto,
      id_uo,
      token,
    };
    const res = await axios.post(API_URL + "createDepositTransactionWithTigoMoney", body);
    if (res.data.code === 200) {
      //successNotification(res.data.message, "top-center");
      dispatch(setIdTransYape(res.data.response_data.transaction.id));
      dispatch(setesperando('ESPERANDO PAGO'));
      setAuto(true);
      setLoading(false);
    } else {
      errorNotification(
        "Ha ocurrido un error, por favor intente de nuevo",
        "top-center"
      );
      setLoading(false);
    }
  }

  const submitPFyape = async(e) => {
    e.preventDefault();

    if (!formPFyape.monto1 || !formPFyape.monto1.trim())
    return errorNotification(
      "Por favor ingrese el monto a depositar",
      "top-center"
    );
    let monto = parseFloat(
      formPFyape.monto1.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    if (monto <= 0)
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );
    if (!formPFyape.telefono || !formPFyape.telefono.trim())
    return errorNotification(
      "Por favor ingrese el numero de billetera Yape",
      "top-center"
    );
    setLoading(true);
    let body = {
      ...formPFyape,
      amount: monto,
      id_uo,
      token,
    };
    const res = await axios.post(API_URL + "createDepositTransactionWithYape", body);

    if (res.data.code === 200) {
      dispatch(setIdTransYape(res.data.response_data.transaction.id));
      dispatch(setmensaje(res.data.response_data.messageSistema));
      setAuto(true);
      dispatch(setShowYape(true));
      dispatch(setesperando('ESPERANDO PAGO'));
      setLoading(false);
    } else {
      if (res.data.message === 'Estado desconocido') {
        errorNotification("Número Telefónico no es válido", "top-center");
        setLoading(false);
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
        setLoading(false);
      }
    }
  }
  const submitPFqr = async(e) => {
    e.preventDefault();

    if (!formPFqr.monto1 || !formPFqr.monto1.trim())
    return errorNotification(
      "Por favor ingrese el monto a depositar",
      "top-center"
    );
    let monto = parseFloat(
      formPFqr.monto1.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    if (monto <= 0)
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );

    setLoading(true);
    let body = {
      ...formPFqr,
      amount: monto,
      id_uo,
      token,
    };
    const res = await axios.post(API_URL + "createDepositTransactionWithQr", body);
   
    if (res.data.code === 200) {

       const values = res.data.response_data.values.split(';')[1];
       const parsedValues = JSON.parse(values);
       const qrImage = parsedValues.qrImage;
       dispatch(setQRPagofacil(qrImage));
       dispatch(setIdTransYape(res.data.response_data.transaction.id));
       dispatch(setShowPagoFacil(true));
       setAuto(true);
       dispatch(setesperando('ESPERANDO PAGO'));
       setLoading(false);
    } else {
      errorNotification(
        "Ha ocurrido un error, por favor intente de nuevo",
        "top-center"
      );
      setLoading(false);
    }
  }

  const submitCoinspaid = async (e) => {
    e.preventDefault();
   

    if (!formCoinspaid.cryptocurrency || !formCoinspaid.cryptocurrency.trim()) {
      return errorNotification("Por favor Seleccione Criptomoneda", "top-center");
    }

    setLoading(true);
    let body = {
      ...formCoinspaid,
      id_uo,
      token
    };

    const res = await axios.post(API_URL + "createCryptoWallet", body);
    if (res.data.code === 200) {
      let address = res.data.response_data.data.address;
      let address_without_prefix = address.replace("bitcoincash:", "");
      let currency = res.data.response_data.data.currency; 
      let network=  res.data.response_data.data.network;; 
      let currencyImage = '';
      const copyIconHTML = ReactDOMServer.renderToString(<CopyIcon style={{ color: 'white' }} />);
      switch (currency) {
        case 'BTC':
          currencyImage = btc;
        break;
        case 'ETH':
          currencyImage = eth;
        break;
        case 'USDTE':
          currencyImage = tether;
        break;
        case 'USDTT':
          currencyImage = tether;
        break;
        case 'BNB':
          currencyImage = bnb;
        break;
        case 'BNB-BSC':
          currencyImage = bnb;
        break;
        case 'USDC':
          currencyImage = usdc;
        break;
        case 'LTC':
          currencyImage = ltc;
        break;
        case 'BCH':
          currencyImage = bch;
        break;
        case 'ADA':
          currencyImage = ada;
        break;
        case 'DOGE':
          currencyImage = doge;
        break;
        case 'XRP':
          currencyImage = xrp;
        break;
        case 'TRX':
          currencyImage = trx;
        break;
      }
      const qrCodeURL = `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${address_without_prefix}`;
      let verificando = {
        html: `
          <div style="display: flex; align-items: center; justify-content: center;">
            ${currencyImage ? `<img src="${currencyImage}" alt="${currency} logo" style="width: 50px; height: 50px; margin-right: 10px;" />` : ''}
            <p style="margin: 0; font-weight: bold;">${currency} - ${network}</p>
          </div>
          <br>
          <p style="font-size: 15px; margin-bottom: 5px;">${t('deposit.red')}: ${network}</p>
          <p style="font-size:15px;">${t('deposit.walletaddress')}: <strong>${address_without_prefix}</strong>  <button id="copy-btn" style="background: none; border: none; cursor: pointer;">
            ${copyIconHTML}
          </button></p>
          <br>
          <p><img src="${qrCodeURL}" alt="QR Code" /></p>
          <br>
          <br>
          <p style="font-size:13px;">${t('deposit.infowallet')} ${minimo} ${currency}-${network}, ${t('deposit.info')} </p>
        `,
        allowOutsideClick: true,
        background: SECONDARY,
        color: "#fff",
        showConfirmButton: true,
        confirmButtonColor: PRIMARY,
        confirmButtonText: `${t('deposit.aceptar')}`
      };

      Swal.fire(verificando);
      setLoading(false);
      document.getElementById('copy-btn').addEventListener('click', () => {
        navigator.clipboard.writeText(address).then(() => {
          const tooltip = document.createElement('span');
          tooltip.innerText = `${t('deposit.copiado')}`;
          tooltip.style.position = 'absolute';
          tooltip.style.bottom = '100%';
          tooltip.style.left = '50%';
          tooltip.style.transform = 'translateX(-50%)';
          tooltip.style.padding = '5px';
          tooltip.style.background = '#333';
          tooltip.style.color = '#fff';
          tooltip.style.borderRadius = '3px';
          tooltip.style.fontSize = '9px';
          tooltip.style.whiteSpace = 'nowrap';

          const button = document.getElementById('copy-btn');
          button.appendChild(tooltip);

          setTimeout(() => {
            button.removeChild(tooltip);
          }, 2000);
        });
      });
    } else {
      if (res.data.message) {
        if(res.data.message.includes("en espera")) {
          let verificado = {
            title: `En espera.`,
            text: `${res.data.message}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificado);
          handleClose();
        }else{
          errorNotification(res.data.message, "top-center");
        }
        setLoading(false);
      } else {
        errorNotification("Ha ocurrido un error, por favor intente de nuevo", "top-center");
        setLoading(false);
      }
    }
  };

  const submitSpei = async(e) => {
    e.preventDefault();

    if (!formSpei.monto1 || !formSpei.monto1.trim())
    return errorNotification(
      "Por favor ingrese el monto a depositar",
      "top-center"
    );
    let monto = parseFloat(
      formSpei.monto1.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    if (monto <= 0)
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );

    setLoading(true);
    let body = {
      ...formSpei,
      monto: monto,
      id_uo,
      token,
    };
    const res = await axios.post(API_URL + "createTransactionSpei", body);
    console.log(res);
    if (res.data.error === 0) {
      if (res.data.data.result.pay_url) {
        let url = res.data.data.result.pay_url;
        window.open(url);
        handleClose();
      }
      setLoading(false);
    } else {
      if (res.data.error) {
        if(res.data.error.includes("en espera")) {
          let verificado = {
            title: `En espera.`,
            text: `${res.data.error}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificado);
          handleClose();
        }else{
          errorNotification(res.data.error, "top-center");
        }
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
      }
      setLoading(false);
    }
  }

  const submitBetterArs = async(e) => {
    e.preventDefault();

    if (!formBetterArs.monto1 || !formBetterArs.monto1.trim())
    return errorNotification(
      "Por favor ingrese el monto a depositar",
      "top-center"
    );
    let monto = parseFloat(
      formBetterArs.monto1.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    if (monto <= 0)
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );

    setLoading(true);
    let body = {
      ...formBetterArs,
      monto: monto,
      id_uo,
      token,
    };
    const res = await axios.post(API_URL + "", body);
    if (res.data.error === 0) {
      if (res.data.data.result.pay_url) {
        let url = res.data.data.result.pay_url;
        window.open(url);
        handleClose();
      }
      setLoading(false);
    } else {
      if (res.data.error) {
        if(res.data.error.includes("en espera")) {
          let verificado = {
            title: `En espera.`,
            text: `${res.data.error}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificado);
          handleClose();
        }else{
          errorNotification(res.data.error, "top-center");
        }
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
      }
      setLoading(false);
    }
  }

  const submitPix = async(e) => {
    e.preventDefault();

    if (!formPix.cpf || !formPix.cpf.trim())
    return errorNotification("Por favor ingrese CPF", "top-center");

    // Elimina espacios, caracteres especiales, guiones y puntos
    const sanitizeCpf = (cpf) => {
        return cpf.replace(/[^\d]/g, ''); // Elimina todo excepto dígitos
    };

    // Actualizamos formPix.cpf con la versión limpia
    formPix.cpf = sanitizeCpf(formPix.cpf);

    // Función para validar el formato y los dígitos verificadores del CPF
    const isValidCpf = (cpf) => {
      if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) {
          return false;
      }

      let sum = 0;
      // Cálculo del primer dígito verificador
      for (let i = 0; i < 9; i++) {
          sum += parseInt(cpf.charAt(i)) * (10 - i);
      }
      let rest = sum % 11;
      let digit1 = (rest < 2) ? 0 : (11 - rest);

      sum = 0;
      // Cálculo del segundo dígito verificador
      for (let i = 0; i < 10; i++) {
          sum += parseInt(cpf.charAt(i)) * (11 - i);
      }
      rest = sum % 11;
      let digit2 = (rest < 2) ? 0 : (11 - rest);

      // Verifica que los dígitos verificadores coincidan
      return (digit1 === parseInt(cpf.charAt(9)) && digit2 === parseInt(cpf.charAt(10)));
    };

    if (!isValidCpf(formPix.cpf))
    return errorNotification("El CPF ingresado no es válido", "top-center");

    if (!formPix.monto1 || !formPix.monto1.trim())
    return errorNotification(
      "Por favor ingrese el monto a depositar",
      "top-center"
    );

    let monto = parseFloat(
      formPix.monto1.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    if (monto <= 0)
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );

    setLoading(true);
    let body = {
      ...formPix,
      monto: monto,
      id_uo,
      token,
    };
    const res = await axios.post(API_URL + "createTransactionPIXIn", body);
    console.log(res);
    
    if (res.data.error === 0) {
      if (res.data.data.result.pay_url) {
        let url = res.data.data.result.pay_url;
        window.open(url);
        handleClose();
      }
      setLoading(false);
    } else {
      if (res.data.error) {
        if(res.data.error.includes("en espera")) {
          let verificado = {
            title: `En espera.`,
            text: `${res.data.error}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificado);
          handleClose();
        }else{
          errorNotification(res.data.error, "top-center");
        }
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
      }
      setLoading(false);
    }
  }

  const submitBoleto = async(e) => {
    e.preventDefault();

    if (!formBoleto.monto1 || !formBoleto.monto1.trim())
    return errorNotification(
      "Por favor ingrese el monto a depositar",
      "top-center"
    );
    let monto = parseFloat(
      formBoleto.monto1.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    if (monto <= 0)
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );

    setLoading(true);
    let body = {
      ...formBoleto,
      monto: monto,
      id_uo,
      token,
    };
    const res = await axios.post(API_URL + "", body);
    if (res.data.error === 0) {
      if (res.data.data.result.pay_url) {
        let url = res.data.data.result.pay_url;
        window.open(url);
        handleClose();
      }
      setLoading(false);
    } else {
      if (res.data.error) {
        if(res.data.error.includes("en espera")) {
          let verificado = {
            title: `En espera.`,
            text: `${res.data.error}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificado);
          handleClose();
        }else{
          errorNotification(res.data.error, "top-center");
        }
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
      }
      setLoading(false);
    }
  }

  const submitBinanceOtro = async(e) => {
    e.preventDefault();

    if (!formBinanceOtro.monto1 || !formBinanceOtro.monto1.trim())
    return errorNotification(
      "Por favor ingrese el monto a depositar",
      "top-center"
    );
    let monto = parseFloat(
      formBinanceOtro.monto1.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    if (monto <= 0)
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );

    setLoading(true);
    let body = {
      ...formBinanceOtro,
      monto: monto,
      id_uo,
      token,
    };
    const res = await axios.post(API_URL + "createTransactionBinancePay", body);
    console.log(res);
    
    if (res.data.error === 0) {
      if (res.data.data.result.pay_url) {
        let url = res.data.data.result.pay_url;
        window.open(url);
        handleClose();
      }
      setLoading(false);
    } else {
      if (res.data.error) {
        if(res.data.error.includes("en espera")) {
          let verificado = {
            title: `En espera.`,
            text: `${res.data.error}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificado);
          handleClose();
        }else{
          errorNotification(res.data.error, "top-center");
        }
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
      }
      setLoading(false);
    }
  }

  const submitAlps = async(e) => {
    e.preventDefault();

    if (!formAlps.monto1 || !formAlps.monto1.trim())
    return errorNotification(
      "Por favor ingrese el monto a depositar",
      "top-center"
    );

    if (!formAlps.channel || !formAlps.channel.trim())
    return errorNotification(
      "Por favor seleccione el metodo de pago",
      "top-center"
    );

    if (!formAlps.document_type || !formAlps.document_type.trim())
    return errorNotification(
      "Por favor seleccione el tipo de documento",
      "top-center"
    );

    if (!formAlps.document || !formAlps.document.trim())
    return errorNotification(
      "Por favor ingrese documento de identidad",
      "top-center"
    );

    let monto = parseFloat(
      formAlps.monto1.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    if (monto <= 0)
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );

    setLoading(true);
    let body = {
      ...formAlps,
      amount: monto,
      id_uo,
      token,
    };
    const res = await axios.post(API_URL + "createDepositTransactionALPS", body);
    if (res.data.code === 200) {
      if (res.data.response_data.url) {
        dispatch(setUrlAlps(res.data.response_data.url));
        dispatch(setShowAlps(true));
        handleClose();
      }
      setLoading(false);
    } else {
      if (res.data.message) {
        if(res.data.message.includes("en espera")) {
          let verificado = {
            title: `En espera.`,
            text: `${res.data.message}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificado);
          handleClose();
        }else{
          errorNotification(res.data.message, "top-center");
        }
        setLoading(false);
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
        setLoading(false);
      }
    }
  }

  const submitAlpsEfectivoChile = async(e) => {
    e.preventDefault();

    if (!formAlpsEfectivoChile.monto1 || !formAlpsEfectivoChile.monto1.trim())
    return errorNotification(
      "Por favor ingrese el monto a depositar",
      "top-center"
    );

    if (!formAlpsEfectivoChile.document_type || !formAlpsEfectivoChile.document_type.trim())
    return errorNotification(
      "Por favor seleccione el tipo de documento",
      "top-center"
    );

    if (!formAlpsEfectivoChile.document || !formAlpsEfectivoChile.document.trim())
    return errorNotification(
      "Por favor ingrese documento de identidad",
      "top-center"
    );

    let monto = parseFloat(
      formAlpsEfectivoChile.monto1.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    if (monto <= 0)
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );

    setLoading(true);
    let body = {
      ...formAlpsEfectivoChile,
      amount: monto,
      id_uo,
      token,
      channel: '2',
    };
    const res = await axios.post(API_URL + "createDepositTransactionALPS", body);
    if (res.data.code === 200) {
      if (res.data.response_data.url) {
        dispatch(setUrlAlps(res.data.response_data.url));
        dispatch(setShowAlps(true));
        handleClose();
      }
      setLoading(false);
    } else {
      if (res.data.message) {
        if(res.data.message.includes("en espera")) {
          let verificado = {
            title: `En espera.`,
            text: `${res.data.message}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificado);
          handleClose();
        }else{
          errorNotification(res.data.message, "top-center");
        }
        setLoading(false);
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
        setLoading(false);
      }
    }
  }

  const submitAlpsTarjetaChile = async(e) => {
    e.preventDefault();

    if (!formAlpsTarjetaChile.monto1 || !formAlpsTarjetaChile.monto1.trim())
    return errorNotification(
      "Por favor ingrese el monto a depositar",
      "top-center"
    );

    if (!formAlpsTarjetaChile.document_type || !formAlpsTarjetaChile.document_type.trim())
    return errorNotification(
      "Por favor seleccione el tipo de documento",
      "top-center"
    );

    if (!formAlpsTarjetaChile.document || !formAlpsTarjetaChile.document.trim())
    return errorNotification(
      "Por favor ingrese documento de identidad",
      "top-center"
    );

    let monto = parseFloat(
      formAlpsTarjetaChile.monto1.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    if (monto <= 0)
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );

    setLoading(true);
    let body = {
      ...formAlpsTarjetaChile,
      amount: monto,
      id_uo,
      token,
      channel: '3',
    };
    const res = await axios.post(API_URL + "createDepositTransactionALPS", body);
    if (res.data.code === 200) {
      if (res.data.response_data.url) {
        
        window.location.href = res.data.response_data.url;
        handleClose();
      }
      setLoading(false);
    } else {
      if (res.data.message) {
        if(res.data.message.includes("en espera")) {
          let verificado = {
            title: `En espera.`,
            text: `${res.data.message}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificado);
          handleClose();
        }else{
          errorNotification(res.data.message, "top-center");
        }
        setLoading(false);
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
        setLoading(false);
      }
    }
  }

  const submitAlpsTransfChile = async(e) => {
    e.preventDefault();

    if (!formAlpsTransfChile.monto1 || !formAlpsTransfChile.monto1.trim())
    return errorNotification(
      "Por favor ingrese el monto a depositar",
      "top-center"
    );

    if (!formAlpsTransfChile.channel || !formAlpsTransfChile.channel.trim())
    return errorNotification(
      "Por favor seleccione el metodo de pago",
      "top-center"
    );

    if (!formAlpsTransfChile.document_type || !formAlpsTransfChile.document_type.trim())
    return errorNotification(
      "Por favor seleccione el tipo de documento",
      "top-center"
    );

    if (!formAlpsTransfChile.document || !formAlpsTransfChile.document.trim())
    return errorNotification(
      "Por favor ingrese documento de identidad",
      "top-center"
    );

    let monto = parseFloat(
      formAlpsTransfChile.monto1.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    if (monto <= 0)
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );

    setLoading(true);
    let body = {
      ...formAlpsTransfChile,
      amount: monto,
      id_uo,
      token,
    };
    const res = await axios.post(API_URL + "createDepositTransactionALPS", body);
    if (res.data.code === 200) {
      if (res.data.response_data.url) {
        dispatch(setUrlAlps(res.data.response_data.url));
        dispatch(setShowAlps(true));
        handleClose();
      }
      setLoading(false);
    } else {
      if (res.data.message) {
        if(res.data.message.includes("en espera")) {
          let verificado = {
            title: `En espera.`,
            text: `${res.data.message}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificado);
          handleClose();
        }else{
          errorNotification(res.data.message, "top-center");
        }
        setLoading(false);
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
        setLoading(false);
      }
    }
  }

  const submitDeuna = async (e) => {
    e.preventDefault();
    if (!formDeuna.monto1 || !formDeuna.monto1.trim())
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );
    let monto = parseFloat(
      formDeuna.monto1.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    if (monto <= 0)
      return errorNotification(
        "El monto a depositar debe ser mayor a 0",
        "top-center"
      );
    setLoading(true);
    let body = {
      monto1: monto,
      id_uo,
      token,
      usuario,
      moneda,
      tipoNotificacion: 'DEUNA',
    };

    const res = await axios.post(
      API_URL + "generarSolicitudDepositoDeuna",
      body
    );
    if (res.data.error === 0) {
      console.log(res.data);
      if (res.data.url) {
        let url = res.data.url;
        window.open(url);
        handleClose();
      }
      setLoading(false);
    } else {
      if (res.data.error) {
        if(res.data.error.includes("en espera")) {
          let verificado = {
            title: `En espera.`,
            text: `${res.data.error}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificado);
          handleClose();
        }else{
          errorNotification(res.data.error, "top-center");
        }
        setLoading(false);
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
        setLoading(false);
      }
    }
  };

  const submitTotalPagoBNC = async (e) => {
    e.preventDefault();
    for (let x in formTotalPagoBNC) {
      if (formTotalPagoBNC[x] === "")
        return errorNotification(
          "Por favor rellene todos los campos",
          "top-center"
        );
    }
    let monto = parseFloat(
      formTotalPagoBNC.monto1.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    setLoading(true);
    const body = {
      ...formTotalPagoBNC,
      fecha: moment(formTotalPagoBNC.fecha).format("DD/MM/YYYY"),
      monto1: monto,
      id_uo,
      usuario,
    };
    let verificando = {
      title: `PAGO EN VERIFICACIÓN.`,
      text: "Estamos verificando su pago, este proceso puede tardar hasta 5 minutos.",
      allowOutsideClick: true,
      icon: "info",
      background: SECONDARY,
      color: "#fff",
      showConfirmButton: true,
      confirmButtonColor: PRIMARY,
      confirmButtonText: "Aceptar",
    };
    Swal.fire(verificando);
    handleClose();
    setLoading(false);

    const res = await axios.post(API_URL + "createTransactionVe", body);
    if (res.data.error === 0) {
      Swal.close();
      let verificado = {
        title: `PAGO VERIFICADO.`,
        text: `Su depósito ha sido procesado satisfactoriamente.`,
        allowOutsideClick: true,
        icon: "success",
        background: SECONDARY,
        color: "#fff",
        showConfirmButton: true,
        confirmButtonColor: PRIMARY,
        confirmButtonText: "Aceptar",
      };
      Swal.fire(verificado);
    } else {
      Swal.close();
      if (res.data.error) {
        if(res.data.error.includes("activa")) {
          let verificado = {
            title: `En espera.`,
            text: `${res.data.error}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificado);
          handleClose();
        }else{
           if(res.data.error.includes("IDPAGO")) {
            let verificado = {
              title: `Ha ocurrido un error.`,
              text: `${res.data.error}`,
              allowOutsideClick: true,
              icon: "info",
              background: SECONDARY,
              color: "#fff",
              showConfirmButton: true,
              confirmButtonColor: PRIMARY,
              confirmButtonText: "Aceptar",
            };
            Swal.fire(verificado);
            handleClose();
          }else{
            errorNotification(res.data.error, "top-center");
          }
        }
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
      }
    }
  };

  const submitKuskiTransf = async(e) => {
    e.preventDefault();

    if (!formKuskiTransf.monto1 || !formKuskiTransf.monto1.trim())
    return errorNotification(
      "Por favor ingrese el monto a depositar",
      "top-center"
    );
    let monto = parseFloat(
      formKuskiTransf.monto1.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    if (monto <= 0)
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );

    setLoading(true);
    let body = {
      ...formKuskiTransf,
      monto: monto,
      id_uo,
      token,
    };
    const res = await axios.post(API_URL + "depositoTransferencia", body);
    console.log(res);
    
    if (res.data.error === 0) {
      if (res.data.data.redirectUrl) {
        dispatch(setUrlKushki(res.data.data.redirectUrl));
        dispatch(setShowKushki(true));
        handleClose();
      }
      setLoading(false);
    } else {
      if (res.data.error !== 0) {
        if(res.data.error.includes("en espera")) {
          let verificado = {
            title: `En espera.`,
            text: `${res.data.error}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificado);
          handleClose();
        }else{
          errorNotification(res.data.error, "top-center");
        }
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
      }
      setLoading(false);
    }
  }

  const submitKushkiEfect = async(e) => {
    e.preventDefault();

    if (!formKushkiEfect.monto1 || !formKushkiEfect.monto1.trim())
    return errorNotification(
      "Por favor ingrese el monto a depositar",
      "top-center"
    );
    let monto = parseFloat(
      formKushkiEfect.monto1.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    if (monto <= 0)
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );

    setLoading(true);
    let body = {
      ...formKushkiEfect,
      monto: monto,
      id_uo,
      token,
    };
    const res = await axios.post(API_URL + "depositoEfectivo", body);
    console.log(res);
    
    if (res.data.error === 0) {
      if (res.data.data.pdfUrl) {
        dispatch(setUrlKushki(res.data.data.pdfUrl));
        dispatch(setShowKushki(true));
        handleClose();
        
      }
      setLoading(false);
    } else {
      if (res.data.error !== 0) {
        if(res.data.error.includes("en espera")) {
          let verificado = {
            title: `En espera.`,
            text: `${res.data.error}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificado);
          handleClose();
        }else{
          errorNotification(res.data.error, "top-center");
        }
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
      }
      setLoading(false);
    }
  }

  const submitKushkiCard = async (e) => {
    e.preventDefault();
    console.log(formKushkiCard)

    // Validaciones previas
    if (!formKushkiCard.card_number || !formKushkiCard.card_number.trim()) {
      return errorNotification(
        "Por favor ingrese el numero de la tarjeta",
        "top-center"
      );
    }
    if (!formKushkiCard.name || !formKushkiCard.name.trim()) {
      return errorNotification(
        "Por favor ingrese el nombre del titular de la tarjeta",
        "top-center"
      );
    }
    if (!formKushkiCard.name || !formKushkiCard.name.trim()) {
      return errorNotification(
        "Por favor ingrese el CVC de la tarjeta",
        "top-center"
      );
    }
    if (!formKushkiCard.expiryMonth || !formKushkiCard.expiryMonth.trim()) {
      return errorNotification(
        "Por favor ingrese el mes de vencimiento de la tarjeta",
        "top-center"
      );
    }
    if (!formKushkiCard.expiryYear || !formKushkiCard.expiryYear.trim()) {
      return errorNotification(
        "Por favor ingrese el año de vencimiento de la tarjeta",
        "top-center"
      );
    }

    if (!formKushkiCard.monto1 || !formKushkiCard.monto1.trim()) {
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );
    }

    let monto = parseFloat(
      formKushkiCard.monto1.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);

    if (monto <= 0) {
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );
    } 

    setLoading(true);
    
    kushki.requestToken({
      amount: monto,
      currency: formatCurrency(moneda),
      card: {
        name: formKushkiCard.name,
        number: formKushkiCard.card_number,
        cvc: formKushkiCard.cvc,
        expiryMonth: formKushkiCard.expiryMonth,
        expiryYear: formKushkiCard.expiryYear
      },
      authValidation: 'url',
      callbackUrl: 'https://masterbets365.com'
    }, (response)=>{
      if(!response.code){
        console.log("kushki ")
        console.log(response);
        console.log("kushki ")

        kushki.requestValidate3DS({
          secureId: response.secureId,
          security: response.security }, (res)=>{
            console.log("res",res);
            
              if(res.isValid) {
                let body = {
                  monto: monto,
                  id_uo,
                  token,
                  token_card: response.token,
                  card_number: formKushkiCard.card_number
                };
                /* let body = {
                  monto: 3001,
                  id_uo,
                  token,
                  token_card: response.token,
                  card_number: "4456528080389860"
                }; */

                // Realiza la solicitud con axios
                axios.post(API_URL + "depositoTarjeta", body)
                  .then((res) => {
                    console.log("depositoTarjeta",res);
                    if (res.data.error === 0) {
                      let verificando = {
                        title: `Procesada exitosamente.`,
                        text: `Transacción procesada exitosamente.`,
                        allowOutsideClick: true,
                        icon: "success",
                        background: SECONDARY,
                        color: "#fff",
                        showConfirmButton: true,
                        confirmButtonColor: PRIMARY,
                        confirmButtonText: "Aceptar",
                      };
                      Swal.fire(verificando);
                      handleClose();
                      setLoading(false);
                    } else {
                      if(res.data.message.includes("en espera")) {
                        let verificado = {
                          title: `En espera.`,
                          text: `${res.data.message}`,
                          allowOutsideClick: true,
                          icon: "info",
                          background: SECONDARY,
                          color: "#fff",
                          showConfirmButton: true,
                          confirmButtonColor: PRIMARY,
                          confirmButtonText: "Aceptar",
                        };
                        Swal.fire(verificado);
                        handleClose();
                      }else{
                        errorNotification(res.data.message, "top-center");
                      }
                      
                      setLoading(false);
                    }
                  })
                  .catch((err) => {
                    console.error("Error al realizar la solicitud:", err);
                    errorNotification(
                      "Ha ocurrido un error, por favor intente de nuevo",
                      "top-center"
                    );
                    setLoading(false);
                  });
              } else {
                errorNotification(
                  "Ha ocurrido un error, por favor intente de nuevo",
                  "top-center"
                );
                setLoading(false);
              }
         });

      } else {
        errorNotification(
          'Error Code: '+ response.code+ ' Message: '+response.message,
          "top-center"
        );
        setLoading(false);
        console.error('Error: ',response.error, 'Code: ', response.code, 'Message: ',response.message);
      }
    }); // Also you can set the function directly

  }; 

  const submitPFqrbisa = async(e) => {
    e.preventDefault();

    if (!formPFqrbisa.monto1 || !formPFqrbisa.monto1.trim())
    return errorNotification(
      "Por favor ingrese el monto a depositar",
      "top-center"
    );
    let monto = parseFloat(
      formPFqrbisa.monto1.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    if (monto <= 0)
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );

    setLoading(true);
    let body = {
      ...formPFqrbisa,
      amount: monto,
      id_uo,
      token,
    };
    const res = await axios.post(API_URL + "createDepositTransactionWithQrBisa", body);
    if (res.data.code === 200) {
       const qrImage = res.data.response_data?.values?.QrBase64;
       dispatch(setQRPagofacil(qrImage));
       dispatch(setIdTransYape(res.data.response_data.transaction.id));
       dispatch(setShowPagoFacil(true));
       setAuto(true);
       dispatch(setesperando('ESPERANDO PAGO'));
       setLoading(false);
    } else {
      errorNotification(
        "Ha ocurrido un error, por favor intente de nuevo",
        "top-center"
      );
      setLoading(false);
    }
  }

  const submitPFqrMercantil = async(e) => {
    e.preventDefault();

    if (!formPFqrMercantil.monto1 || !formPFqrMercantil.monto1.trim())
    return errorNotification(
      "Por favor ingrese el monto a depositar",
      "top-center"
    );
    let monto = parseFloat(
      formPFqrMercantil.monto1.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    if (monto <= 0)
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );

    setLoading(true);
    let body = {
      ...formPFqrMercantil,
      amount: monto,
      id_uo,
      token,
    };
    const res = await axios.post(API_URL + "createDepositTransactionWithQrMercantil", body);
    if (res.data.code === 200) {
       const qrImage = res.data.response_data?.values?.QrBase64;
       dispatch(setQRPagofacil(qrImage));
       dispatch(setIdTransYape(res.data.response_data.transaction.id));
       dispatch(setShowPagoFacil(true));
       setAuto(true);
       dispatch(setesperando('ESPERANDO PAGO'));
       setLoading(false);
    } else {
      errorNotification(
        "Ha ocurrido un error, por favor intente de nuevo",
        "top-center"
      );
      setLoading(false);
    }
  }

  const submitOxxo = async(e) => {
    e.preventDefault();

    if (!formOxxo.monto1 || !formOxxo.monto1.trim())
    return errorNotification(
      "Por favor ingrese el monto a depositar",
      "top-center"
    );

    if (!formOxxo.tipodocumento || !formOxxo.tipodocumento.trim())
    return errorNotification(
      "Por favor seleccione el tipo de documento",
      "top-center"
    );

    if (!formOxxo.documento || !formOxxo.documento.trim())
    return errorNotification(
      "Por favor ingrese el documento de identidad",
      "top-center"
    );

    if (formOxxo.tipodocumento === 'RFC' && (formOxxo.documento.length !== 12 && formOxxo.documento.length !== 13)) {
      return errorNotification(
        "RFC debe contener 12 o 13 dígitos",
        "top-center"
      );
    }

    if (formOxxo.tipodocumento === 'CURP' && formOxxo.documento.length !== 18) {
      return errorNotification(
        "CURP debe contener 18 dígitos",
        "top-center"
      );
    }


    let monto = parseFloat(
      formOxxo.monto1.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    if (monto <= 0)
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );

    setLoading(true);
    let body = {
      ...formOxxo,
      monto: monto,
      id_uo,
      token,
    };
    const res = await axios.post(API_URL + "createTransactionOXXO", body);
    console.log(res);
    if (res.data.error === 0) {
      if (res.data.data.result.pay_url) {
        let url = res.data.data.result.pay_url;
        window.open(url);
        handleClose();
      }
      setLoading(false);
    } else {
      if (res.data.error) {
        if(res.data.error.includes("en espera")) {
          let verificado = {
            title: `En espera.`,
            text: `${res.data.error}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificado);
          handleClose();
        }else{
          errorNotification(res.data.error, "top-center");
        }
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
      }
      setLoading(false);
    }
  }

  const submitMonnetGTQCash = async(e) => {
    e.preventDefault();

    if (!formMonnetGTQCash.monto1 || !formMonnetGTQCash.monto1.trim())
    return errorNotification(
      "Por favor ingrese el monto a depositar",
      "top-center"
    );
  
    let monto = parseFloat(
      formMonnetGTQCash.monto1.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    if (monto <= 0)
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );

    setLoading(true);
    let body = {
      ...formMonnetGTQCash,
      amount: monto,
      id_uo,
      token,
      payment_method: "Cash",

    };
    const res = await axios.post(API_URL + "createDepositTransaction", body);
    if (res.data.code === 200) {
      if (res.data.response_data.url) {
        let url = res.data.response_data.url;
        window.open(url);
        handleClose();
      }
      setLoading(false);
    } else {
      if (res.data.message) {
        if(res.data.message.includes("en espera")) {
          let verificado = {
            title: `En espera.`,
            text: `${res.data.message}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificado);
          handleClose();
        }else{
          errorNotification(res.data.message, "top-center");
        }
        setLoading(false);
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
        setLoading(false);
      }
    }
  }

  const submitMonnetGTQTransf = async(e) => {
    e.preventDefault();

    if (!formMonnetGTQTransf.monto1 || !formMonnetGTQTransf.monto1.trim())
    return errorNotification(
      "Por favor ingrese el monto a depositar",
      "top-center"
    );
  
    let monto = parseFloat(
      formMonnetGTQTransf.monto1.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    if (monto <= 0)
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );

    setLoading(true);
    let body = {
      ...formMonnetGTQTransf,
      amount: monto,
      id_uo,
      token,
      payment_method: "BankTransfer",

    };
    const res = await axios.post(API_URL + "createDepositTransaction", body);
    console.log(res);
    if (res.data.code === 200) {
      if (res.data.response_data.url) {
        let url = res.data.response_data.url;
        window.open(url);
        handleClose();
      }
      setLoading(false);
    } else {
      if (res.data.message) {
        if(res.data.message.includes("en espera")) {
          let verificado = {
            title: `En espera.`,
            text: `${res.data.message}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificado);
          handleClose();
        }else{
          errorNotification(res.data.message, "top-center");
        }
        setLoading(false);
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
        setLoading(false);
      }
    }
  }

  const submitTransPYG = async(e) => {
    e.preventDefault();

    if (!formTransPYG.monto1 || !formTransPYG.monto1.trim())
    return errorNotification(
      "Por favor ingrese el monto a depositar",
      "top-center"
    );
    let monto = parseFloat(
      formTransPYG.monto1.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    if (monto <= 0)
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );

    setLoading(true);
    let body = {
      ...formTransPYG,
      monto: monto,
      id_uo,
      token,
    };
    const res = await axios.post(API_URL + "createTransactionParaguayHPP", body);
    console.log(res);
    if (res.data.error === 0) {
      if (res.data.data.result.pay_url) {
        let url = res.data.data.result.pay_url;
        window.open(url);
        handleClose();
      }
      setLoading(false);
    } else {
      if (res.data.error) {
        if(res.data.error.includes("en espera")) {
          let verificado = {
            title: `En espera.`,
            text: `${res.data.error}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificado);
          handleClose();
        }else{
          errorNotification(res.data.error, "top-center");
        }
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
      }
      setLoading(false);
    }
  }

  const submitMonnetTarjetaEcu = async(e) => {
    e.preventDefault();

    if (!formMonnetTarjetaEcu.monto1 || !formMonnetTarjetaEcu.monto1.trim())
    return errorNotification(
      "Por favor ingrese el monto a depositar",
      "top-center"
    );
   if (!formMonnetTarjetaEcu.metodo || !formMonnetTarjetaEcu.metodo.trim())
    return errorNotification(
      "Por favor seleccione el metodo de pago",
      "top-center"
    );
    let monto = parseFloat(
      formMonnetTarjetaEcu.monto1.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    if (monto <= 0)
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );

    setLoading(true);
    let body = {
      ...formMonnetTarjetaEcu,
      amount: monto,
      id_uo,
      token,
      payment_method: formMonnetTarjetaEcu.metodo,

    };
    const res = await axios.post(API_URL + "createDepositTransaction", body);
    if (res.data.code === 200) {
      if (res.data.response_data.url) {
        let url = res.data.response_data.url;
        window.open(url);
        handleClose();
      }
      setLoading(false);
    } else {
      if (res.data.message) {
        if(res.data.message.includes("en espera")) {
          let verificado = {
            title: `En espera.`,
            text: `${res.data.message}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificado);
          handleClose();
        }else{
          errorNotification(res.data.message, "top-center");
        }
        setLoading(false);
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
        setLoading(false);
      }
    }
  }

  const submitMonnetBancosCH = async(e) => {
    e.preventDefault();

    if (!formMonnetBancosCH.monto1 || !formMonnetBancosCH.monto1.trim())
    return errorNotification(
      "Por favor ingrese el monto a depositar",
      "top-center"
    );
   if (!formMonnetBancosCH.metodo || !formMonnetBancosCH.metodo.trim())
    return errorNotification(
      "Por favor seleccione el metodo de pago",
      "top-center"
    );
    let monto = parseFloat(
      formMonnetBancosCH.monto1.replaceAll(".", "").replace(",", ".")
    ).toFixed(2);
    if (monto <= 0)
      return errorNotification(
        "Por favor ingrese el monto a depositar",
        "top-center"
      );

    setLoading(true);
    let body = {
      ...formMonnetBancosCH,
      amount: monto,
      id_uo,
      token,
      payment_method: formMonnetBancosCH.metodo,

    };
    const res = await axios.post(API_URL + "createDepositTransaction", body);
    if (res.data.code === 200) {
      if (res.data.response_data.url) {
        let url = res.data.response_data.url;
        handleClose();
        window.location.href = url; // Redirige en la misma pestaña
      }
      setLoading(false);
    } else {
      if (res.data.message) {
        if(res.data.message.includes("en espera")) {
          let verificado = {
            title: `En espera.`,
            text: `${res.data.message}`,
            allowOutsideClick: true,
            icon: "info",
            background: SECONDARY,
            color: "#fff",
            showConfirmButton: true,
            confirmButtonColor: PRIMARY,
            confirmButtonText: "Aceptar",
          };
          Swal.fire(verificado);
          handleClose();
        }else{
          errorNotification(res.data.message, "top-center");
        }
        setLoading(false);
      } else {
        errorNotification(
          "Ha ocurrido un error, por favor intente de nuevo",
          "top-center"
        );
        setLoading(false);
      }
    }
  }

  const clearForm = () => {
    setForm(initialForm);
    setFormPay4Fun(initialFormPay4Fun);
    setFormTotalPago(initialFormTotalPago);
    setFormTotalPagoBFC(initialFormTotalPagoBFC);
    setFormSafetyPay(initialFormSafetyPay);
    setFormAstroPay(initialFormAstroPay);
    setFormNuvei(initialFormNuvei);
    setFormPayRetailer(initialFormPayRetailer);
    setFormTuPay(initialFormTuPay);
    setFormTuPayXAQR(initialFormTuPayXAQR);
    setFormTuPayXACC(initialFormTuPayXACC);
    setFormMonnet(initialFormMonnet);
    setFormMonnetYape(initialFormMonnetYape);
    setFormMonnetTarjeta(initialFormMonnetTarjeta);
    setFormMonnetBancos(initialFormMonnetBancos);
    setformPFtigomoney(initialFormPFtigomoney);
    setformPFyape(initialFormPFyape);
    setformPFqr(initialFormPFqr);
    setformCoinspaid(initialFormCoinspaid);
    setformSpei(initialFormSpei);
    setformBetterArs(initialFormBetterArs);
    setformPix(initialFormPix);
    setformBoleto(initialFormBoleto);
    setformBinanceOtro(initialFormBinanceOtro);
    setformAlps(initialFormAlps);
    setformDeuna(initialFormDeuna);
    setFormTotalPagoBNC(initialFormTotalPagoBNC);
    setformKuskiTransf(initialFormKushkiTransf);
    setformKushkiEfect(initialFormKushkiEfect);
    setformKushkiCard(initialFormKushkiCard);
    setformPFqrbisa(initialFormPFqrbisa);
    setformPFqrMercantil(initialFormPFqrMercantil);
    setformAlpsEfectivoChile(initialFormAlpsEfectivoChile);
    setformAlpsTarjetaChile(initialFormAlpsTarjetaChile);
    setformAlpsTransfChile(initialFormAlpsTransfChile);
    setformOxxo(initialFormOxxo);
    setformMonnetGTQCash(initialFormMonnetGTQCASH);
    setformMonnetGTQTransf(initialFormMonnetGTQTRANSF);
    setformTransPYG(initialFormTransPYG);
    setFormMonnetTarjetaEcu(initialFormMonnetTarjetaEcu);
    setFormMonnetBancosCH(initialFormMonnetBancosCH);

  };

  return {
    loading,
    form,
    formAstroPay,
    formPayRetailer,
    formPay4Fun,
    formSafetyPay,
    formTotalPago,
    formTotalPagoBFC,
    formTuPay,
    formTuPayXAQR,
    formTuPayXACC,
    formNuvei,
    formPagoEfectivo,
    formMonnet,
    formMonnetYape,
    formMonnetTarjeta,
    formMonnetBancos,
    formPFtigomoney,
    formPFyape,
    formPFqr,
    formCoinspaid,
    formSpei,
    formBetterArs,
    formPix,
    formBoleto,
    formBinanceOtro,
    formAlps,
    formDeuna,
    formTotalPagoBNC,
    formKuskiTransf,
    formKushkiEfect,
    formKushkiCard,
    formPFqrbisa,
    formPFqrMercantil,
    formAlpsEfectivoChile,
    formAlpsTarjetaChile,
    formAlpsTransfChile,
    formOxxo,
    formMonnetGTQCash,
    formMonnetGTQTransf,
    formTransPYG,
    formMonnetTarjetaEcu,
    formMonnetBancosCH,
    image,
    zelleAct,
    bancosRetailer,
    loadingBancosRetailer,
    setImage,
    clearForm,
    handleChange,
    handleChangeRetailer,
    handleChangeTotalPago,
    handleChangeTotalPagoBFC,
    handleChangeSafetyPay,
    handleChangeAstroPay,
    handleChangeNuvei,
    handleChangePayRetailer,
    handleChangeTuPay,
    handleChangeTuPayXAQR,
    handleChangeTuPayXACC,
    handleChangePagoEfectivo,
    handleChangeMonnet,
    handleChangeMonnetTarjeta,
    handleChangeMonnetYape,
    handleChangeMonnetBancos,
    handleChangePFtigomoney,
    handleChangePFyape,
    handleChangePFqr,
    handleChangeCoinspaid,
    handleChangeSpei,
    handleChangeBetterArs,
    handleChangePix,
    handleChangeBoleto,
    handleChangeBinanceOtro,
    handleChangeAlps,
    handleChangeDeuna,
    handleChangeTotalPagoBNC,
    handleChangeKuskiTransf,
    handleChangeKushkiEfect,
    handleChangeKushkiCard,
    handleChangePFqrbisa,
    handleChangePFqrMercantil,
    handleChangeAlpsEfectivoChile,
    handleChangeAlpsTarjetaChile,
    handleChangeAlpsTransfChile,
    handleChangeOxxo,
    handleChangeMonnetGTQCash,
    handleChangeMonnetGTQTransf,
    handleChangeTransPYG,
    handleChangeMonnetTarjetaEcu,
    handleChangeMonnetBancosCH,
    handleSubmit,
    submitPagoEfectivo,
    submitPay4Fun,
    submitTotalPago,
    submitTotalPagoBFC,
    submitSafetypay,
    submitAstroPay,
    submitNuvei,
    submitPayRetailer,
    submitTuPay,
    submitTuPayXAQR,
    submitTuPayXACC,
    submitMonnet,
    submitMonnetYape,
    submitMonnetTarjeta,
    submitMonnetBancos,
    submitPFtigomoney,
    submitPFyape,
    submitPFqr, 
    submitCoinspaid, 
    submitSpei,
    submitBetterArs,
    submitPix,
    submitBoleto,
    submitBinanceOtro,
    submitAlps,
    submitDeuna,
    submitTotalPagoBNC,
    submitKuskiTransf,
    submitKushkiEfect,
    submitKushkiCard,
    submitPFqrbisa, 
    submitPFqrMercantil, 
    submitAlpsEfectivoChile,
    submitAlpsTarjetaChile,
    submitAlpsTransfChile,
    submitOxxo,
    submitMonnetGTQCash,
    submitMonnetGTQTransf,
    submitTransPYG,
    submitMonnetTarjetaEcu,
    submitMonnetBancosCH,
    auto
  };
};
